import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthenticate } from '../use-authenticate/use-authenticate';
import { useEffect } from 'react';

export const useAuthGuard = () => {
  const { isAuthenicated } = useAuthenticate();
  const { pathname: redirectUrl } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenicated) {
      navigate(`/user/sign-in?redirect=${redirectUrl}`);
    }
  }, []);
};
